import type { Ref } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue'
import { useDebounceFn } from './use-debounce-fn'

interface UseElementSize {
  width: Readonly<Ref<number>>
  heigth: Readonly<Ref<number>>
}
/**
 * The Composable returns the dimensions of an Element when it changes.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
 */
export function useElementSize(element: Ref<HTMLElement>): UseElementSize {
  const width = ref<number>(0)
  const heigth = ref<number>(0)

  const resizeObserverCallback = useDebounceFn((entries: Array<ResizeObserverEntry>): void => {
    for (const entry of entries) {
      if (entry.contentBoxSize) {
        const contentBoxSize = entry.contentBoxSize[0]
        width.value = contentBoxSize.inlineSize
        heigth.value = contentBoxSize.blockSize
      }
    }
  }, 100)

  const resizeObserver = new ResizeObserver(resizeObserverCallback)

  onMounted(() => {
    resizeObserver?.observe(element.value)
  })

  onUnmounted(() => {
    resizeObserver.disconnect()
  })

  return {
    width,
    heigth,
  }
}
